import { ComponentPropsWithoutRef } from 'react'
import { ChangeHandler } from 'react-hook-form'
import { cn } from '~shared/utils/cn'

export interface InputProps extends ComponentPropsWithoutRef<'input'> {
  register?: {
    onChange: ChangeHandler
    onBlur: ChangeHandler
    ref: React.Ref<any>
    name: string
  }

  isError?: boolean
}

export const Input = (props: InputProps) => {
  const { className, isError = false, register, ...rest } = props

  return (
    <input
      {...register}
      type='text'
      className={cn(
        'rounded-[16px] h-[67px] bg-primary placeholder:text-[16px] placeholder:text-input-placeholder placeholder:leading-[1.1] pl-4',
        isError && 'text-danger',
        className
      )}
      {...rest}
    />
  )
}
